var _use, _symbol;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIonic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 85 85",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A",
    x: 2.5,
    y: 2.5
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "A",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.329 12.288c0 1.407-.521 2.69-1.377 3.675C77.002 22.66 80 30.986 80 40c0 22.056-17.944 40-40 40S0 62.056 0 40 17.944 0 40 0c9.014 0 17.34 2.998 24.037 8.049.986-.856 2.268-1.376 3.676-1.376a5.62 5.62 0 0 1 5.617 5.616zM40 78.654c21.314 0 38.654-17.341 38.653-38.655a38.45 38.45 0 0 0-7.702-23.13c-.916.649-2.031 1.033-3.24 1.033-3.101 0-5.616-2.514-5.616-5.615 0-1.208.385-2.324 1.033-3.24A38.45 38.45 0 0 0 40 1.345C18.686 1.345 1.345 18.686 1.345 40S18.686 78.654 40 78.654zm0-22.323c-9.02 0-16.331-7.312-16.331-16.331S30.981 23.668 40 23.668 56.332 30.98 56.332 40 49.02 56.331 40 56.331z",
    fill: "#4e8ef7",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIonic);
export default __webpack_public_path__ + "static/media/ionic.9f8f71f14c8d6a8d3e3e3e9933fa88d7.svg";
export { ForwardRef as ReactComponent };